import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import { usePreorder } from '../context/PreorderContext';
import { Lock, Clock } from 'lucide-react';
import { getProductMedia } from '../data/mock';
import { formatMoney } from '../lib/format';

const PreorderDialog = () => {
  const { dialogProduct, setDialogProduct, setPending } = usePreorder();
  const navigate = useNavigate();
  const [size, setSize] = React.useState('');

  React.useEffect(() => {
    if (dialogProduct?.sizes?.length) setSize(dialogProduct.sizes[0]);
  }, [dialogProduct]);

  if (!dialogProduct) return null;

  const { primary } = getProductMedia(dialogProduct);
  const price = dialogProduct.sizePrices?.[size] ?? dialogProduct.price;

  const continueToCheckout = () => {
    setPending(dialogProduct, size, 1);
    setDialogProduct(null);
    navigate('/checkout');
  };

  return (
    <Dialog open={!!dialogProduct} onOpenChange={(o) => !o && setDialogProduct(null)}>
      <DialogContent className="bg-[#F5EDDD] border-[#C9B596] rounded-none max-w-md p-0 overflow-hidden">
        <div className="aspect-[16/9] overflow-hidden bg-[#EDE3CF]">
          {primary && (
            <img src={primary} alt={dialogProduct.name} className="w-full h-full object-cover" />
          )}
        </div>
        <div className="p-6">
          <DialogHeader>
            <p className="text-[10px] tracking-[0.32em] uppercase text-[#A07A4F] mb-2 flex items-center gap-2">
              <Clock className="h-3.5 w-3.5" strokeWidth={1.5} /> Preorder · Ships 6–10 weeks
            </p>
            <DialogTitle
              className="text-2xl text-[#33200F] font-normal text-left"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Order the {dialogProduct.name}
            </DialogTitle>
            <DialogDescription className="text-[#5B3A24] text-[14px] leading-[1.85] text-left pt-1">
              Made on request in Melbourne. Pick a size, then continue to checkout to enter your details and choose how to pay.
            </DialogDescription>
          </DialogHeader>
          <div className="mt-6 space-y-5">
            {dialogProduct.sizes?.length > 1 && (
              <div>
                <label className="text-[11px] tracking-[0.22em] uppercase text-[#A07A4F] mb-2 block">Size</label>
                <div className="flex flex-wrap gap-2">
                  {dialogProduct.sizes.map((s) => (
                    <button
                      key={s}
                      type="button"
                      onClick={() => setSize(s)}
                      className={`px-4 h-10 text-[12px] border transition-colors ${
                        size === s
                          ? 'border-[#33200F] bg-[#33200F] text-[#F5EDDD]'
                          : 'border-[#C9B596] text-[#33200F] hover:border-[#33200F]'
                      }`}
                    >
                      {s}
                    </button>
                  ))}
                </div>
              </div>
            )}
            <Button
              onClick={continueToCheckout}
              data-testid="preorder-checkout-btn"
              className="w-full bg-[#33200F] text-[#F5EDDD] hover:bg-[#1E140B] rounded-none h-12 text-[12px] tracking-[0.22em] uppercase"
            >
              <span className="inline-flex items-center gap-2"><Lock className="h-4 w-4" /> Continue to checkout · {formatMoney(price)}</span>
            </Button>
            <p className="text-[11px] text-[#A07A4F] text-center">Card · Apple Pay · Google Pay · Afterpay accepted on the next screen.</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PreorderDialog;
